export default __webpack_public_path__ + "static/media/stepsFirstFrame.07bca921.svg";